export enum StateTax {
  Alabama = 0.04,
  Alaska = 0,
  Arizona = 0.056,
  Arkansas = 0.065,
  California = 0.725,
  Colorado = 0.029,
  Connecticut = 0.635,
  Delaware = 0,
  DistrictOfColumbia = 0.06,
  Florida = 0.06,
  Georgia = 0.04,
  Guam = 0.04,
  Hawaii = 0.04166,
  Idaho = 0.06,
  Illinois = 0.0625,
  Indiana = 0.07,
  Iowa = 0.06,
  Kansas = 0.065,
  Kentucky = 0.06,
  Louisiana = 0.0445,
  Maine = 0.055,
  Maryland = 0.06,
  Massachusetts = 0.625,
  Michigan = 0.06,
  Minnesota = 0.06875,
  Mississippi = 0.07,
  Missouri = 0.04225,
  Montana = 0,
  Nebraska = 0.055,
  Nevada = 0.0685,
  NewHampshire = 0,
  NewJersey = 0.06625,
  NewMexico = 5.125,
  NewYork = 0.04,
  NorthCarolina = 0.0475,
  NorthDakota = 0.05,
  Ohio = 0.0575,
  Oklahoma = 0.045,
  Oregon = 0,
  Pennsylvania = 0.06,
  PuertoRico = 0.105,
  RhodeIsland = 0.07,
  SouthCarolina = 0.06,
  SouthDakota = 0.04,
  Tennessee = 0.07,
  Texas = 0.0625,
  Utah = 0.0595,
  Vermont = 0.06,
  Virginia = 0.053,
  Washington = 0.065,
  WestVirginia = 0.06,
  Wisconsin = 0.05,
  Wyoming = 0.04
}
